import { useEffect, useReducer } from 'react'
import { useSearchParams } from 'react-router-dom'
import { createTimeRange } from '../utils/dateUtils'

const initialChartOptions = {
  timeRange: { duration: 'allTime' },
}

function chartOptionsReducer(state, action) {
  switch (action.type) {
    case 'INITIALIZE_OPTIONS':
      return { timeRange: action.payload.initialTimeRange }
    case 'SET_TIME_RANGE':
      return { ...state, timeRange: action.payload }
    default:
      throw new Error(`Unhandled action type: ${action.type}`)
  }
}

export function useChartOptions() {
  const [searchParams] = useSearchParams()
  const [options, dispatch] = useReducer(chartOptionsReducer, initialChartOptions)

  useEffect(() => {
    const initializeOptions = async () => {
      const secondsParam = searchParams.get('seconds')
      const initialTimeRange = secondsParam ? await createTimeRange(+secondsParam) : { duration: 'allTime' }

      dispatch({
        type: 'INITIALIZE_OPTIONS',
        payload: { initialTimeRange },
      })
    }
    
    initializeOptions()
  }, [searchParams])

  return { options, dispatch }
}
